import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMode } from '../../reducers/sidebar';
import { getMapLayers } from '../../reducers/mapLayers';
import { getPlan } from '../../reducers/plan';
import { getMapLoaded } from '../../reducers/mapRefs';
import { renderLayers, renderPlan } from '../../utils/map-google/mapUtils';

const MapLayer = () => {
  const mode = useSelector(getMode);
  const mapLayers = useSelector(getMapLayers);
  const plan = useSelector(getPlan);
  const mapLoaded = useSelector(getMapLoaded);

  useEffect(() => {
    if (mapLoaded) {
      switch (mode) {
        case 'layers':
          renderLayers(mapLayers);
          break;
        case 'plan':
          renderPlan(plan, mapLayers);
          break;
        default:
          break;
      }
    }
  }, [mode, mapLayers, plan, mapLoaded]);

  return <></>;
};

export default MapLayer;
